import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { ResultData, ResultsData, UIService } from 'src/app/core/services/ui.service';
import { Invoice } from 'src/app/modelo/Invoice';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { InvoiceGlobal } from 'src/app/modelo/InvoiceGlobal';
import { validateDNIPattern } from 'src/app/shared/helpers';
import { FacturasService } from '../facturas.service';
import { DataService } from 'src/app/services/data.service';
import { AppComponent } from 'src/app/app.component';
import { DataAssistantListUX } from 'src/app/modelo/DataAssistantListUX';
import { DataAssistantUX } from 'src/app/modelo/DataAssistantUX';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { saveAs } from 'file-saver';
import { PlanOrganizacion } from 'src/app/modelo/PlanOrganizacion';
import { Reporte } from 'src/app/modelo/Reporte';
import { AdministracionService } from 'src/app/administracion/administracion.service';

import { FiltroData } from 'src/app/modelo/FiltroData';
import { FiltrosData } from 'src/app/modelo/FiltrosData';
import { VeronicaAPIErrorResultData, VeronicaApiSubErrorData } from 'src/app/modelo/VeronicaAPIErrorData';

@Component({
    selector: 'app-retencion-servicio',
    templateUrl: './retencion-servicio.component.html',
    styleUrls: ['./retencion-servicio.component.scss']
})
export class RetencionServicioComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    invoiceGlobal: InvoiceGlobal = new InvoiceGlobal();
    internalStatusInvoiceCountTotal: number = 0;
    facturas: Invoice[] = [];
    facturasSeleccionados: Invoice[];
    factura: Invoice = new Invoice();

    //Variables de reportes
    mostrarVisualidorReporteRIDE: boolean = false;
    mostrarVisualidorReporte: boolean = false;
    reporteGenerado: boolean = false;
    reporteFactura: Invoice = {} as Invoice;
    reporteURL: any; //Para lanzar el popup de vista previa
    reporteBLOB: any; //Para descargar el reporte
    planOrganizacion: PlanOrganizacion = new PlanOrganizacion();

    //Variables auxiliares
    cols: any[];
    _selectedColumns: any[];
    multiSortMeta = [];
    enabledTotals: boolean = false;
    tieneFacturas: boolean = false;
    buttonsActions: any[] = [];
    mostrarPopupFacturaInvalida: boolean = false;
    mostrarPlanPopup: boolean = false;

    //Facturas inválidas
    colsPorStatus: any[];
    multiSortMetaPorStatus = [];
    enabledTotalsPorStatus: boolean = false;
    facturasPorStatus: Invoice[] = [];
    facturasPorStatusSeleccionados: Invoice[];
    buttonsFacturasInvalidas: any[] = [];
    mostrarPopupFacturasInvalidas: boolean = false;
    tituloListadoPorStatus: string = "";

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;
    app: AppComponent;

    status: string = "";

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    catalogoReportes: Reporte[] = [];
    reporte: Reporte = new Reporte();
    mostrarSelectorReporte: boolean = false;

    dtRangeInit: Date;
    dtRangeEnd: Date;
    dtRangeMonth: boolean = false;

    filtrosData: FiltrosData = new FiltrosData();
    resultsData: ResultsData;
    mostrarMensajesResultData: boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private facturasService: FacturasService,
        private comprobantesService: ComprobantesService,
        private sanitizer: DomSanitizer,
        private administracionService: AdministracionService
    ) {
        this.ui = uiService;
        moment.locale('es');
        this.cargarDataConstructor();

        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_listado.pdf');
        this.pageDescription = 'En esta opción usted podrá crear nuevas retenciones para sus clientes, además de visualizar las facturas que fueron emitidas con éxito o tuvieron alguna observación por parte del SRI.';
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Retenciones', routerLink: ['retenciones'] }
        ]);
        this.cols = [
            { field: 'fechaEmision', header: 'Fecha de Emisión', visible: true },
            { field: 'secuencial', header: 'Secuencial', visible: true },
            { field: 'claveAcceso', header: 'Clave de acceso', visible: false },
            { field: 'customerFullName', header: 'Cliente', visible: true },
            { field: 'resumen', header: 'Resumen', visible: true },
            { field: 'importeTotal', header: 'Valor Total', visible: false, class: 'p-text-right' },
        ];
        this._selectedColumns = this.cols.filter(col => col.visible == true);

        this.multiSortMeta.push({ field: 'emissionOn', order: -1 });

        this.colsPorStatus = [
            { field: 'fechaEmision', header: 'Fecha de Emisión', visible: true },
            { field: 'secuencial', header: 'Secuencial', visible: true },
            { field: 'customerFullName', header: 'Cliente', visible: true },
            { field: 'resumen', header: 'Resumen', visible: true },
            { field: 'importeTotal', header: 'Valor Total', visible: false, class: 'p-text-right' },
        ];
        this.multiSortMetaPorStatus.push({ field: 'emissionOn', order: -1 });

        this.status = 'APPLIED';
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.invoiceGlobal = await this.comprobantesService.getRetencionesEnviadasRecibidasPorUsuarioConectadoData();
        this.invoiceGlobal.mostrarAlertaRecarga = this.invoiceGlobal.numeroComprobantesPorEmitir < this.invoiceGlobal.minimoComprobantesAlertarRecarga;

        if (this.invoiceGlobal) {
            if (this.invoiceGlobal.invoicesEmitidasData) {
                this.facturas = this.ui.updateDateFormatInvoice(this.invoiceGlobal.invoicesEmitidasData);//Actualizar fechaEmission
                this.tieneFacturas = this.facturas.length > 0; //Para mostrar el buscador si hay en que buscar
                this.tituloListadoPorStatus = "Retenciones Emitidas";
                this.breadcrumbService.setItems([
                    { label: this.tituloListadoPorStatus, routerLink: ['facturas/retenciones/'] }
                ]);
            }
            if (this.invoiceGlobal.invoicesEmitidasCountData) {
                this.buttonsFacturasInvalidas = [];
                this.invoiceGlobal.invoicesEmitidasCountData.forEach(element => {
                    this.internalStatusInvoiceCountTotal = this.internalStatusInvoiceCountTotal + element['count'];
                    let color: string = element.color == 'tertiary' ? 'help' : element.color == 'medium' ? 'info' : element.color;
                    let cssClass = 'p-button-sm p-button-' + color + ' m-1';
                    let buttonFacturaInvalida = {
                        text: element.status,
                        cssClass: cssClass,
                        status: element.internalStatus,
                        data: element.count,
                        disabled: false,
                    }
                    this.buttonsFacturasInvalidas.push(buttonFacturaInvalida);
                });
            }
        }

        //Cargar plan
        this.planOrganizacion = this.currentUser.organization.planOrganizacion;

        this.cargandoDataInit = false;
    }

    @Input() get selectedColumns(): any[] {
        return this._selectedColumns;
    }

    set selectedColumns(val: any[]) {
        //restore original order
        this._selectedColumns = this.cols.filter(col => val.includes(col));
    }

    presentarOpcionesActionSheet(event, item: Invoice) {
        let buttonCobrarEnabled: boolean = (item && item.isPayment);

        if (this.status == 'POSTED') {
            this.buttonsActions = [
                {
                    text: 'Enviar para autorizar',
                    icon: 'pi pi-envelope',
                    cssClass: 'p-button-text p-button-info',
                    action: 'reenviar',
                    data: item,
                    disabled: false,
                }, {
                    text: 'Nueva a partir de la seleccionada',
                    icon: 'pi pi-clone',
                    cssClass: 'p-button-text p-button-plain',
                    action: 'duplicar',
                    data: item,
                    disabled: !this.invoiceGlobal.puedeFacturarPorPlan,
                }
            ];
        } else if (this.status == 'CREATED') {
            this.buttonsActions = [
                {
                    text: 'Enviar para autorizar',
                    icon: 'pi pi-envelope',
                    cssClass: 'p-button-text p-button-info',
                    action: 'reenviar',
                    data: item,
                    disabled: false,
                }
            ];
        } else if (this.status == 'APPLIED') {
            this.buttonsActions = [
                {
                    text: 'Reenviar a mi cliente',
                    icon: 'pi pi-envelope',
                    cssClass: 'p-button-text p-button-info',
                    action: 'reenviar',
                    data: item,
                    disabled: false,
                }, {
                    text: 'Nueva a partir de la seleccionada',
                    icon: 'pi pi-clone',
                    cssClass: 'p-button-text p-button-plain',
                    action: 'duplicar',
                    data: item,
                    disabled: !this.invoiceGlobal.puedeFacturarPorPlan,
                },
                {
                    text: 'Marcar como anulada',
                    icon: 'pi pi-flag',
                    cssClass: 'p-button-text p-button-plain',
                    action: 'anular',
                    data: item,
                    disabled: false,
                }, {
                    text: 'Marcar como cobrada',
                    icon: 'pi pi-dollar',
                    cssClass: 'p-button-text p-button-plain',
                    action: 'cobrar',
                    data: item,
                    disabled: buttonCobrarEnabled,
                }, {
                    text: 'Imprimir',
                    icon: 'pi pi-print',
                    cssClass: 'p-button-text p-button-plain',
                    action: 'imprimir',
                    data: item,
                }
            ];
        } else {
            this.buttonsActions = [];
        }

    }

    /**
    * Comandos sobre las filas de la tabla
    */
    cmds(row): any {

        let items = [];
        if (this.status == 'POSTED' || this.status == 'CREATED' || this.status == 'REJECTED') {
            items = [
                {
                    label: 'Reenviar al SRI',
                    icon: 'pi pi-envelope', command: () => {
                        this.enviarSRI(row); //Reenvia al SRI sin afectar las secuencias
                    }
                }
            ];
        } else if (this.status == 'APPLIED') {
            items = [
                {
                    label: 'Nueva a partir de esta',
                    icon: 'pi pi-clone', command: () => {
                        this.irAClonarFactura(row);
                    }
                },
                {
                    label: 'Marcar como anulada',
                    icon: 'pi pi-clone', command: () => {
                        this.confirmarAnulacionFactura(row);
                    }
                },
                {
                    label: 'Marcar como cobrada',
                    icon: 'pi pi-clone', command: () => {
                        this.confirmarPagoFactura(row);
                    }
                },
                { separator: true },
                {
                    label: 'Reenviar a mi cliente',
                    icon: 'pi pi-clone', command: () => {
                        this.notificarFactura(row);
                    }
                },
            ];
        } else if (this.status == 'INVALID') {
            items = [
                {
                    label: 'Ver Error',
                    icon: 'pi pi-clone', command: () => {
                        this.irAVerError(row);
                    }
                },
            ]
        } else {
            items = [
                {
                    label: 'Nueva a partir de esta',
                    icon: 'pi pi-clone', command: () => {
                        this.irAClonarFactura(row);
                    }
                },
                {
                    label: 'Ver Error',
                    icon: 'pi pi-clone', command: () => {
                        this.irAVerError(row);
                    }
                },
            ];
        }
        return items; //[{label: "Una comando", command: () => { this.dummy (x); }}];   
    }

    dummy(item: any) {
    }

    irAClonarFactura(row: any) {
        this.router.navigate(['/fazil/facturas/factura/extendido', row.uuid]);
    }

    ejecutarAccion(event, accion: string, f: Invoice) {
        this.ui.limpiarMessages();
        if (accion == 'reenviar') {
            const tipo = "facturas";
            const url = `${environment.settings.apiServer}/comprobantes/${tipo}/${f.claveAcceso}/notificar`
            this.notificarFactura(f);
        } else if (accion == 'duplicar') {
            //Ir a popup factura
            this.router.navigate(['/fazil/facturas/factura/extendido', f.uuid]);
        } else if (accion == 'anular') {
            //Mostrar popup para anular factura
        } else if (accion == 'cobrar') {
            this.confirmarPagoFactura(f);
        } else if (accion == 'imprimir') {
            this.imprimirFactura(f);
        } else if (accion == 'enviarsri') {
            this.enviarSRI(f);
        }
    }

    async viewFacturasPorStatus(event, statusLabel: string, status: string, count: number) {
        this.status = status;
        this.tituloListadoPorStatus = "Retenciones " + statusLabel;

        this.breadcrumbService.setItems([
            { label: this.tituloListadoPorStatus, routerLink: ['retenciones'] }
        ]);

        //        this.facturasPorStatus = this.ui.updateDateFormatInvoice(await this.comprobantesService.getComprobantesPorUsuarioConectadoYEstadoData(status));//Actualizar fechaEmission
        //        this.mostrarPopupFacturasInvalidas = true;
        this.facturas = this.ui.updateDateFormatInvoice(await this.comprobantesService.getRetencionesPorUsuarioConectadoYEstadoData(status));//Actualizar fechaEmission
    }

    async nuevaRetencion(event) {
        if (this.currentUser.tieneCertificadoDigital && this.currentUser.puedeFacturarPorPlan) {
            await this.fazilService.irARetencion();
        } else {
            await this.fazilService.irARegistrarCertificadoDigital();
        }
    }

    async notificarFactura(factura: Invoice) {
        this.procesando = true;

        let header = "";
        let body = "";
        let type = "";
        factura.fechaEmision = null; //Corregir la fecha de emision para corregir request

        //Guardar la factura en persistencia para luego recargar las facturas
        this.comprobantesService.notificarFactura("facturas", factura).subscribe(
            async (data) => {

                if (data['errors']) {
                    this.resultDataButtons = [];
                    let dataError = data['errors'];
                    if (dataError['type'] == 'error-plan') {
                        header = dataError['message'].split('.')[0];
                        body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                        this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                        this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                    } else {
                        header = this.appConfig.ux.messages.error;
                        body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500;
                        this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    }
                    type = dataError['type'] ? dataError['type'] : 'error';
                    this.resultData = { header: header, body: body, type: type, subErrors: null };
                    this.procesando = false;
                    this.mostrarResultData = true;
                } else {
                    type = this.appConfig.ux.messages.success;
                    header = this.appConfig.ux.messages.success;
                    body = `Retención ${data.secuencial} notificada a ${data.customerFullName}<${data.customerEmail}>`;
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    this.resultData = { header: header, body: body, type: type, subErrors: null };
                    this.procesando = false;
                    this.mostrarResultData = true;
                }
            },
            async (err) => {
                header = this.appConfig.ux.messages.error;
                type = this.appConfig.ux.messagesType.error;
                body = (err && err["message"]) ? err["message"] : environment.settings.errorMsgs.error500;
                this.resultData = { header: header, body: body, type: type, subErrors: null };
                this.resultDataButtons = [];
                this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                this.procesando = false;
                this.mostrarResultData = true;
            }
        );
    }

    async imprimirFactura(factura: Invoice) {

        this.reporteBLOB = null;
        this.reporteURL = null;
        this.reporteGenerado = false;
        this.mostrarVisualidorReporteRIDE = false;

        const tipo = 'retenciones';
        /*const title = `Hola te saluda ${this.currentUser.nombre}, adjunto factura ${factura.secuencial}`;
        const summary = `${title}.\nQue grato servirte con ${factura.resumen
            } por un monto de ${factura.importeTotal.toFixed(2)}, emisión ${factura.fechaEmision
            }.\n\nAhora facturar es más FAZil con el app de facturación exclusiva para profesionales, buscala en el AppStore\n\n`;
        const url = `${environment.settings.apiServer}/comprobantes/${tipo}/${factura.claveAcceso}/archivos/pdf`;
        */



        this.comprobantesService.downloadVeroinicaRIDE(tipo, factura.claveAcceso).subscribe(
            (responseBlob: any) => {

                let blob: any = new Blob([responseBlob], { type: responseBlob.type });

                const fileReader = new FileReader();
                fileReader.onload = () => {
                    this.reporteFactura = factura;
                    this.reporteURL = new Uint8Array(fileReader.result as ArrayBuffer);
                    this.reporteGenerado = true;
                    this.mostrarVisualidorReporteRIDE = true;
                    this.procesando = false;

                };
                if (blob['type'] != '' && blob['size'] != 0) {
                    fileReader.readAsArrayBuffer(blob);
                    this.reporteBLOB = blob;
                } else {
                    this.mostrarVisualidorReporteRIDE = true;
                    this.reporteGenerado = false;
                    this.procesando = false;
                }

            },
            (err) => {
                this.errors = err["errors"];
                this.messageService.add({
                    severity: "error",
                    summary: this.errors["type"],
                    detail: `${this.errors["message"]}`,
                });
            }
        );

        //        this.app.sendShare(summary, title, url);
    }
    async enviarSRI(factura: Invoice) {
        this.router.navigate(['/fazil/facturas/retenciones/retencion', factura.uuid]);
    }

    confirmarPagoFactura(factura: Invoice): void {
        this.confirmationService.confirm({
            message: "¿Está seguro de cobrar la factura Nº. <strong>" + factura.secuencial + "</strong>?.",
            accept: () => {
                this.guardarPagoFactura(factura);
            },
        });
    }

    async guardarPagoFactura(factura: Invoice) {
        this.procesando = true;
        if (factura && factura.id && factura.importeTotal) {
            //Guardar en persistencia
            this.comprobantesService.enviarFacturaPago(factura).subscribe(
                async (data) => {
                    this.cargarDataInit();
                    this.procesando = false;
                    this.ui.mostrarMensaje("success", `Retención marcada como pagada.`);
                },
                async (err) => {
                    this.procesando = false;
                    this.ui.mostrarMensaje("error", (err && err["message"] ? err["message"] : environment.settings.errorMsgs.error500));
                }
            );
        }
    }


    confirmarAnulacionFactura(factura: Invoice): void {
        this.confirmationService.confirm({
            message: "¿Está seguro de marcar como anulado el comprobante Nº. <strong>" + factura.secuencial + "</strong>?.",
            accept: () => {
                this.anularFactura(factura);
            },
        });
    }

    async anularFactura(factura: Invoice) {
        this.procesando = true;
        if (factura && factura.id && factura.importeTotal) {
            //Guardar en persistencia marcando como anulado
            this.comprobantesService.enviarFacturaAnulada(factura).subscribe(
                async (data) => {
                    this.cargarDataInit();
                    this.procesando = false;
                    this.ui.mostrarMensaje("success", `Factura marcada como anulada.`);
                },
                async (err) => {
                    this.procesando = false;
                    this.ui.mostrarMensaje("error", (err && err["message"] ? err["message"] : environment.settings.errorMsgs.error500));
                }
            );
        }
    }

    /**
     ** Métodos de formulario
     **/
    recargarPlan($event) {
        this.fazilService.irALanding();
    }

    verTotalesFacturas(event, tipo: string) {
        if (tipo == 'main') {
            this.enabledTotals = !this.enabledTotals;
            let columnTotal = this.cols.find(item => item.field === 'importeTotal');
            columnTotal['visible'] = this.enabledTotals;
            this.cols[this.cols.indexOf(columnTotal)] = columnTotal;
        } else if (tipo == 'status') {
            this.enabledTotalsPorStatus = !this.enabledTotalsPorStatus;
            let columnTotal = this.colsPorStatus.find(item => item.field == 'importeTotal');
            columnTotal['visible'] = this.enabledTotalsPorStatus
            this.colsPorStatus[this.colsPorStatus.indexOf(columnTotal)] = columnTotal;

        }
    }

    descargarReporte() {
        this.saveAsPDFFile(this.reporteBLOB, "RIDE");
    }

    /**
       * Manejo de archivos PDF
       */
    saveAsPDFFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.pdf';
            const path = fileName + '_descarga_' + new Date().getTime().toString() + ZIP_EXTENSION;
            saveAs(blob, path);
        });
    }

    /**
    * Manejo de archivos EXCEL
    */
    saveAsEXCELFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.xls';
            const path = fileName + '_descarga_' + new Date().getTime().toString() + ZIP_EXTENSION;
            saveAs(blob, path);
        });
    }

    irAAssistentOpcion(event) {
        if (event && event.option) {
            switch (event.option['key']) {
                case 'ruc':
                    this.fazilService.irAInformacionSRI();
                    break;
                case 'producto':
                    this.fazilService.irAProductosServicios();
                    break;
                case 'contacto':
                    this.fazilService.irAContactos();
                    break;
                case 'plan':
                    this.cargarPlan(event);
                    break;
                case 'certificado_digital':
                    this.fazilService.irARegistrarCertificadoDigital();
                    break;
                default:
                    break;
            }
        }
    }

    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }

    generateItemsToXLS(event) {
        this.verificandoData = this.ui.buildResultFromVerify("Generando .xlsx de facturas", this.appConfig.ux.messagesType.success);
        this.verificando = true;
        this.ui.downloadXLSXWithColsHidden(this.facturas, 'facturas', this.cols);
        this.verificando = false;
    }

    async generateItemsToPDFByReporte(event) {
        this.ui.limpiarMessages();
        //Cargar reportes, sino se ha cargado
        if (this.catalogoReportes.length == 0){
            this.catalogoReportes = await this.administracionService.getReportesPorModuloClaseData(this.router.url, 'lista'); //Volver a cargar
        }
        
        this.reporte = new Reporte();
        if (false && this.catalogoReportes && this.catalogoReportes.length == 1) {
            //Generar el reporte directamente
            this.reporte = this.catalogoReportes[0];
            this.generarReportePorFiltros(event);
        } else {
            //Seleccionar el reporte de la lista
            this.mostrarSelectorReporte = true;
        }
    }

    /**
    * Manejo de reportes
    */
    async generarReportePorFiltros(event: any) {
        this.reporteBLOB = null;
        this.reporteURL = null;
        this.reporteGenerado = false;
        this.mostrarVisualidorReporte = false;
        this.filtrosData.filtros = [];
        this.filtrosData.tipo = "excel";
        let filtro;

        filtro = new FiltroData();
        filtro.token = 'Titulo';
        filtro.valor = this.reporte.name;
        this.filtrosData.filtros.push(filtro);

        filtro = new FiltroData();
        filtro.token = 'estadoSRI';
        filtro.valor = this.status ? this.status : "APPLIED";
        this.filtrosData.filtros.push(filtro);


        if (this.dtRangeInit) {//Cargar el filtro de fechas

            filtro = new FiltroData();
            filtro.token = 'fechaInicial';
            filtro.valor = "" + this.dtRangeInit.toLocaleDateString();
            filtro.tipo = "Date";
            this.filtrosData.filtros.push(filtro);

            filtro = new FiltroData();
            filtro.token = 'fechaFinal';
            filtro.tipo = "Date";

            if (this.dtRangeEnd) {
                filtro.valor = "" + this.dtRangeEnd.toLocaleDateString();
            } else {
                filtro.valor = "" + new Date().toLocaleDateString();
            }
            this.filtrosData.filtros.push(filtro);
        }


        //Solicitar reporte con filtros
        if (this.filtrosData && this.filtrosData.filtros && this.filtrosData.filtros.length > 0) {

            //Parámetros del reporte
            if (this.reporte.url && this.reporte.url != '') {
                this.procesando = true;
                this.administracionService.generarReportePorFiltros(this.reporte.uuid, this.filtrosData).subscribe(
                    (responseBlob: any) => {

                        let blob: any = new Blob([responseBlob], { type: responseBlob.type });

                        if (this.filtrosData.tipo == 'pdf') {
                            const fileReader = new FileReader();
                            fileReader.onload = () => {
                                this.reporteURL = new Uint8Array(fileReader.result as ArrayBuffer);
                                this.reporteGenerado = true;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;

                            };
                            if (blob['type'] != '' && blob['size'] != 0) {
                                fileReader.readAsArrayBuffer(blob);
                                this.reporteBLOB = blob;
                            } else {
                                this.reporteGenerado = false;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;
                            }
                        } else {
                            this.saveAsEXCELFile(blob, this.reporte.name);
                            this.reporteGenerado = true;
                            this.mostrarVisualidorReporte = false;
                            this.procesando = false;
                        }

                    },
                    (err) => {
                        this.errors = err["errors"];
                        this.messageService.add({
                            severity: "error",
                            summary: this.errors["type"],
                            detail: `${this.errors["message"]}`,
                        });
                    }
                );
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Reporte inconsistente",
                    detail: `${this.reporte["nombre"]} no esta correctamente definido. Consulte con el administrador.`,
                });

                this.procesando = false;
            }
        }
    }

    cargarPlan(event) {
        this.mostrarPlanPopup = true;
    }

    /**
    **Manejo de filtros
    **/
    onFilterDate(event) {//Aplicar todos los filtros
        if (this.dtRangeInit && this.dtRangeEnd) {
            this.dtRangeInit.setHours(0, 0, 0, 0);
            this.dtRangeEnd.setHours(23, 59, 59, 59);
        } else if (this.dtRangeInit) {
            this.dtRangeInit.setHours(0, 0, 0, 0);
        } else {
        }
    }

    onFilterDateRange(event) {
        if (event) {
            this.dtRangeInit = null;
            this.dtRangeEnd = null;
            if (event.checked) {
                this.dtRangeInit = new Date();
                //                if (new Date().getMonth().valueOf() == 0) {
                //                    this.dtRangeInit.setFullYear(new Date().getFullYear() - 1, 11, new Date().getDay());
                //                } else {
                this.dtRangeInit.setMonth(new Date().getMonth() - 1);
                //                }
                this.dtRangeInit.setHours(0, 0, 0, 0);
                this.dtRangeEnd = new Date();
                this.dtRangeEnd.setHours(23, 59, 59, 59);
            } else {
                this.dtRangeInit = null;//Enserar el rango de fechas
                this.dtRangeEnd = null;
            }
        }
    }

    async limpiarFiltros() {
        this.dtRangeInit = null;
        this.dtRangeEnd = null;
        //this.tipoFiltro = null;
        this.reporte = new Reporte();
        this.dtRangeMonth = false;
    }

    async irAVerError(row: Invoice) {
        let dato = await this.comprobantesService.getSRIMensajesData(row.claveAcceso, this.appConfig.ux.messagesError.tableSriWithholding);
        let mensajes: any[] = dato['mensajes'];

        let header = this.appConfig.ux.messagesError.header;
        let body = this.appConfig.ux.messagesError.body;
        let type = this.appConfig.ux.messagesError.type;
        let subErros: VeronicaApiSubErrorData[] = [];
        mensajes.forEach(item => {
            let subErro: VeronicaApiSubErrorData = new VeronicaApiSubErrorData();

            subErro.object = item['tipo'];
            subErro.field = item['identificador'];
            subErro.rejectedValue = item['mensaje'];
            subErro.message = item['informacionAdicional'];
            subErros.push(subErro);

        })
        this.resultDataButtons = [];
        this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
        this.resultsData = { header: header, body: body, type: type, subErrors: subErros };
        this.mostrarMensajesResultData = true;
    }
}
